"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function ApplicableLaw() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "direito-aplicavel"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement("strong", null, "7. DO DIREITO APLIC\xC1VEL E DO FORO")), /*#__PURE__*/_react["default"].createElement("p", null, "Para a solu\xE7\xE3o das controv\xE9rsias decorrentes do presente instrumento, ser\xE1 aplicado integralmente o Direito brasileiro."), /*#__PURE__*/_react["default"].createElement("p", null, "Os eventuais lit\xEDgios dever\xE3o ser apresentados no foro da comarca em que est\xE1 localizada a sede da ", /*#__PURE__*/_react["default"].createElement("strong", null, "TAUGOR"), "."));
}
var _default = ApplicableLaw;
exports["default"] = _default;